import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect } from "react-router";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import TextAreaInputField from "@eres/forms-web/TextAreaInputField";
import FormAction from "@my-dld/components/Form/FormAction";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import Dropzone from "react-dropzone";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import { hideLoading, LoadableDataState, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { AttachmentInfo } from "@eres/ejari-api/Entity/tenant";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { JOPServiceIds } from "./index";
import { OwnerCommitteeApi } from "../../ownercommitteeapi";
import { JOPRequest, JOPServiceEntry } from "../../ownercommitteeapi/entities";
import { ErrorContainer, NullableFormValue } from "@eres/forms";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import { OwnerCommitteeLookupTransformer } from "../../ownercommitteeapi/utils";
import StateHolder from "@eres/forms/StateHolder";
import { WebFormFieldProps } from "@eres/forms-web";
import FormRow from "@eres/forms-web/FormRow";
import PickerInput from "@eres/forms-web/PickerInput";
import { DashboardSectionTitle } from "../MyDLD/Portfolio/Summary";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { checkValidationErrorWithMessage } from "../../ownercommitteeapi/api";
import { Lookup } from "@eres/ejari-api/Entity";
import { LocaleUtil } from "@eres/core";
import ConfirmationPopup from "@my-dld/components/Popup/ConfirmationPopup";
import SuccessPopup from "./SuccessPopup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { JOPContext } from "@my-dld/contexts/JOPContext";
import DateInputField from "@eres/forms-web/DateInputField";
import { JOPApi } from "./Api";

interface Props extends RoutedViewProps {
	type: "enquiry" | "suggestion" | "complaints" | "legal";
}

export interface IJOPServices {
	canInquiry?: boolean;
	canLegal?: boolean;
	canSuggestion?: boolean;
	canComplaint?: boolean;
}
interface FormState {
	category?: Lookup;
	type?: Lookup;
	description?: string;
	attachments?: any[];
}

interface State extends FormState, LoadableDataState {
	property?: AssetCard | any;
	lookups?: Lookup[];
	subLookups?: Lookup[];
	entries?: LegalRequestList[];
	confirmCancel?: boolean;
	entryToDeleteIndex?: number;
	requestReference?: string;
	meetingDate?: string;
	userType?: number;
}

interface LegalRequestList {
	category: Lookup;
	type: Lookup;
	description: string;
	attachments?: any[];
}

const MAX_SIZE = 2 * 1024 * 1000;
const MAX_PAGES = 10;

const JOPServiceSuccessPopup = "JOPServiceSuccessPopup";

class JOPService extends Component<Props, State> {
	static contextType = JOPContext;
	context!: React.ContextType<typeof JOPContext>;

	constructor( props: Props ) {
		super( props );
		const userType = props.location.state ? props.location.state.userType : undefined;
		this.state = { errorContainer: {}, loadState: "done", entries: [], subLookups: [], userType: userType };

	}

	getParentId() {
		switch ( this.props.type ) {
			case "complaints":
				return JOPServiceIds.COMPLAINT;
			case "enquiry":
				return JOPServiceIds.ENQUIRY;
			case "legal":
				return JOPServiceIds.LEGAL;
			case "suggestion":
				return JOPServiceIds.SUGGESTION;
		}
	}

	getLookups() {
		const parentId = this.getParentId();
		JOPApi.getJOPServiceCategoryLookup( parentId , this.state.userType! )
		.then( r => this.processResponse( r, "lookups" ) )
		.catch( reason => {
			showErrorMessage( reason );
		} );
	}

	componentDidMount() {
		this.getLookups();
		this.setState( { property: this.context.property } );
	}

	private onCategoryChanged = ( v: NullableFormValue<Lookup, Lookup> ) => {
		const parentId = this.getParentId();
		if (  v != null ) { // parentId === JOPServiceIds.LEGAL &&
			this.setState( { subLookups: undefined, category: undefined }, () => {
				JOPApi.getJOPServiceSubCategoryLookup( v.Id, this.state.userType! )
				.then( r => this.processResponse( r, "subLookups" ) )
				.catch( reason => {
					showErrorMessage( reason );
				} );
			} );
		}
	};

	private processResponse = <K extends keyof State>( r: any, key: K ) => {
		if ( r.validationErrorsList && r.validationErrorsList.length > 0 ) {
			showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
		} else if ( r.response && r.response.items && r.response.items.length > 0 ) {
			this.setState( { [ key ]: r.response.items.map( OwnerCommitteeLookupTransformer ) } as unknown as Pick<State, keyof State> );
		}
	};

	render() {
		const state = this.state;
		const errorContainer = this.state.errorContainer;
		const confirmCancel = state.confirmCancel;
		const type = this.props.type;
		const property = state.property ?? this.context.property;
		console.log("PROPERTY -", property)
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( property );
		const fieldProps: Partial<WebFormFieldProps<any, any>> = { holder: StateHolder.buildStateHolder( this ), errorManager: defaultErrorManager };
		return <PageContent
			title={ `${ Strings[ type ] } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ Strings.jop_services } paths={ [ DashboardBCItem ] }/>
			<FormRow { ...fieldProps } containerClassName={ "col-md-3 form-group" }>
				<PickerInput
					items={ state.lookups }
					id={ "type" }
					toIdentifier={ IdExtractor }
					label={ Strings.category }
					required={ true }
					onValueChange={ this.onCategoryChanged }
					isLoading={ state.lookups == null }/>
				 <PickerInput
					items={ state.subLookups }
					id={ "category" }
					toIdentifier={ IdExtractor }
					label={ Strings.sub_category }
					required={ true }
					isLoading={ state.subLookups == null }/>
			</FormRow>
			<FormRow { ...fieldProps } containerClassName={ "col-md-6 form-group" }>
				{ state.type?.Id === 16 ? <DateInputField
					required={ true }
					label={ Strings.owner_committee_meeting_date }
					id={ "meetingDate" }
					extraOpts={ {
						minDate: new Date()
					} }
				/> : null }
			</FormRow>
			<FormRow { ...fieldProps } containerClassName={ "col-md-6 form-group" }>
				<TextAreaInputField id={ "description" } label={ Strings.description } required={ true }/>
			</FormRow>
			<FormRow { ...fieldProps } containerClassName={ "col-md-6 form-group" }>
				<div key={ "doc_info" } className="col-md-6 form-group">
					<Dropzone
						multiple={ true }
						maxSize={ MAX_SIZE }
						onDropRejected={ this.onDropRejected }
						onDrop={ ( files: File[] ) => {
							this.onDrop( files );
						} }
						accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
						{ ( { getRootProps, getInputProps } ) => (
							<DocumentInputField
								{ ...getRootProps() }
								required={ false }
								dropZoneInputProps={ getInputProps() }
								label={ Strings.attached_documents }
								// isDocsAdded={ isDocsAdded }
								error={ errorContainer.attachments }
								// disabled={ ( docLookup.Docs && docLookup.Docs.length === maxPages ) }
							/>
						) }
					</Dropzone>
					<span>
                        <small>{ Strings.tabu_upload_documents_note }</small><br/>
                        <small>{ Strings.max_num_files + " : " + MAX_PAGES }</small>
                    </span>
					<Docs onDelete={ this.onDelete } documents={ state.attachments }/>
				</div>
			</FormRow>
			<FormRow>
				<FormAction
					primaryActionLabel={ type === "legal" ? Strings.add : Strings.submit }
					onPrimaryAction={ type === "legal" ? this.onAdd : this.onSubmit }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }/>
			</FormRow>
			{ type === "legal" ? <>
				<div className={ "row" }>
					<DashboardSectionTitle title={ Strings.legal_request_list }/>
				</div>
				<ListDataView
					id={ "LegalRequestsList" } items={ state.entries } renderListItem={ this.renderListItem }
					renderListHeader={ this.renderHeaderItem } isSearchable={ false }/>
				<FormRow>
					<FormAction primaryActionLabel={ Strings.submit } onPrimaryAction={ this.onSubmit }/>
				</FormRow>
			</> : null }
			{ confirmCancel ? <ConfirmationPopup
				message={ Strings.delete_entry_confirm }
				onConfirm={ this.onCancel }
				onCancel={ this.hideCancelConfirmation }/> : null }
			<SuccessPopup onDismiss={ this.onDismiss } applicationRef={ state.requestReference }/>
		</PageContent>;
	}

	onDismiss = () => {
		JQModal( JOPServiceSuccessPopup ).hide();
		this.props.history.goBack();
		this.props.history.goBack();
	};

	hideCancelConfirmation = () => {
		this.setState( { confirmCancel: false, entryToDeleteIndex: undefined } );
	};

	onCancel = () => {
		this.setState( {
			entries: this.state.entries?.filter( ( _, index ) => index !== this.state.entryToDeleteIndex ),
			entryToDeleteIndex: undefined,
			confirmCancel: false,
		} );
	};

	uploadDocuments = () => {
		let uploadTasks: Promise<any>[] = [];
		const docs = this.state.attachments;

		if ( this.getParentId() === JOPServiceIds.LEGAL ) {
			this.state.entries?.forEach( ( entry, index ) => {
				if ( entry.attachments ) {
					entry.attachments.forEach( ( doc: any ) => {
						if ( doc.documentId == null ) {
							uploadTasks.push( JOPApi.uploadJOPDocument( doc.localFile ).then( ( response ) => {
								return checkValidationErrorWithMessage( response );
							} ).then( response => {
								if ( response.responseCode === "Success" && response.response ) {
									doc.documentId = response.response.id;
									doc.entryIndex = index;
									return Promise.resolve( doc );
								}
								return Promise.resolve( doc );
							} ).catch( reason => {
								return Promise.reject( reason.toString() );
							} ) );
						} else {
							uploadTasks.push( Promise.resolve( doc ) );
						}
					} );
				}
			} );
		} else {
			docs?.map( ( doc: any ) => {
				if ( doc.documentId == null ) {
					uploadTasks.push( JOPApi.uploadJOPDocument( doc.localFile ).then( ( response ) => {
						return checkValidationErrorWithMessage( response );
					} ).then( response => {
						if ( response.responseCode === "Success" && response.response ) {
							doc.documentId = response.response.id;
							return Promise.resolve( doc );
						}
						return Promise.resolve( doc );
					} ).catch( reason => {
						return Promise.reject( reason.toString() );
					} ) );
				} else {
					uploadTasks.push( Promise.resolve( doc ) );
				}
			} );
		}

		return Promise.all( uploadTasks );
	};

	onAdd = () => {
		if ( this.validateForm( false ) ) {
			const entry: LegalRequestList = {
				type: this.state.type!,
				description: this.state.description + "",
				category: this.state.category!,
				attachments: this.state.attachments,
			};
			this.setState( {
				entries: this.state.entries ? [ ...this.state.entries, entry ] : [ entry ],
				type: undefined,
				description: undefined,
				category: undefined,
				attachments: undefined,
			} );
		}
	};

	onSubmit = () => {
		const state = this.state;
		const property = state.property ?? this.context.property;
		const propertyId = property?.PropertyId ? property?.PropertyId! : property?.propertyId!
		if ( this.validateForm() ) {
			showLoading();
			this.uploadDocuments()
			.then( ( docs ) => {
				let request: JOPRequest;
				if ( this.getParentId() === JOPServiceIds.LEGAL ) {
					request = {
						applicantTypeId: this.state.userType!,
						ownerNumber: TabuProfile.getParticipantNumber()!,
						jopServiceTypeId: this.getParentId(),
						propertyId: propertyId,
						jopServiceEntry: this.state.entries!.map( ( entry, index ) => {
							return {
								category: { identity: entry.type.Id },
								subCategory: { identity: entry.type.Id },
								description: entry.description,
								documents: docs.filter( d => d.entryIndex === index ).map( filteredDoc => {
									return {
										id: filteredDoc.documentId,
									};
								} ),
							} as JOPServiceEntry;
						} ),
					};
				} else {
					request = {
						applicantTypeId: this.state.userType!,
						ownerNumber: TabuProfile.getParticipantNumber()!,
						jopServiceTypeId: this.getParentId(),
						propertyId: propertyId,
						jopServiceEntry: [ {
							category: { identity: this.state.type?.Id! },
							description: this.state.description + "",
							subCategory: { identity: this.state.category?.Id! },
							documents: docs?.map( doc => ( { id: doc.documentId } ) ),
							meetingDate: this.state.meetingDate,
						} ]
					};
				}
				JOPApi.submitJOPRequest( propertyId, request )
				.then( r => {
					hideLoading();
					if ( r.validationErrorsList && r.validationErrorsList.length > 0 ) {
						showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
					} else if ( r.response && r.response.referenceNumber ) {
						this.setState( { requestReference: r.response.referenceNumber }, () => {
							JQModal( JOPServiceSuccessPopup ).show();
						} );
					}
				} )
				.catch( reason => {
					hideLoading();
					showErrorMessage( reason );
				} );
			} )
			.catch( reason => {
				hideLoading();
				showErrorMessage( reason );
			} );
		}
	};

	validateForm( validateLegal = true ) {
		if ( this.getParentId() === JOPServiceIds.LEGAL && validateLegal ) {
			if ( this.state.entries == null || this.state.entries.length === 0 ) {
				showErrorMessage( Strings.add_one_entry );
			} else {
				return true;
			}
		} else {
			let isValid = true;
			let errorViews: ErrorContainer = {};
			const state = this.state;
			isValid = checkNonEmpty( state, "type", errorViews ) && isValid;
			if ( this.getParentId() === JOPServiceIds.LEGAL ) {
				isValid = checkNonEmpty( state, "category", errorViews ) && isValid;
			}
			isValid = checkNonEmpty( state, "description", errorViews ) && isValid;
			this.setState( { errorContainer: errorViews } );
			return isValid;
		}
	}

	onDropRejected = () => {
		showErrorMessage( Strings.tabu_file_exceed_size );
	};

	private onDrop = ( files: File[] ) => {
		const docs = this.state.attachments;
		if ( MAX_PAGES > 1 ) {
			if ( docs && docs.length > 1 ) {
				let maxAllowed = ( MAX_PAGES - docs.length );
				if ( files.length > maxAllowed ) files = files.splice( 0, maxAllowed );
			} else if ( files.length > MAX_PAGES ) {
				files = files.splice( 0, MAX_PAGES );
			}
		}
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( file ) );
	};

	private addFile( file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			let d = this.state.attachments ? [ ...this.state.attachments ] : [];
			const binaryStr = reader.result;
			if ( d == null ) d = [];
			const newDoc = {
				Type: file.type,
				LocalData: binaryStr as string,
				FileName: file.name,
				localFile: file,
			};
			if ( MAX_PAGES > 1 ) {
				d.push( newDoc );
			} else {
				d = [ newDoc ];
			}
			let error = this.state.errorContainer;
			delete error.attachments;
			this.setState( {
				attachments: d,
				errorContainer: error,
			} );
		};
		reader.readAsDataURL( file );
	}

	renderListItem = ( item: LegalRequestList, index: number ) => {
		return <tr>
			<td>{ index + 1 }</td>
			<td>{ LocaleUtil.getLocalValue( item.type ) }</td>
			<td>{ LocaleUtil.getLocalValue( item.category ) }</td>
			<td>{ item.description }</td>
			<td>
				<Docs documents={ item.attachments }/>
			</td>
			<td>
				<button onClick={ () => this.onDeleteEntry( index ) } className={ "btn btn-grey" }>
					<i className="fa fa-trash" aria-hidden="true"/>
				</button>
			</td>
		</tr>;
	};

	renderHeaderItem = () => {
		return <tr>
			<th>#</th>
			<th>{ Strings.category }</th>
			<th>{ Strings.sub_category }</th>
			<th>{ Strings.description }</th>
			<th>{ Strings.documents }</th>
			<th></th>
		</tr>;
	};

	onDeleteEntry = ( index: number ) => {
		this.setState( { entryToDeleteIndex: index, confirmCancel: true } );
	};

	onBack = () => {
		this.props.history.goBack();
		this.props.history.goBack()
	};

	onDelete = ( index: number ) => {
		const { attachments } = this.state;

		const d = attachments?.filter( ( _: any, i: number ) => i !== index );
		this.setState( {
			attachments: d,
		} );
	};
}

interface DocsProps {
	documents?: AttachmentInfo[];
	onDelete?: ( index: number ) => void;
}

export function Docs( props: DocsProps ) {
	const { documents, onDelete } = props;
	if ( documents && documents.length > 0 ) {
		return <>
			{ documents.map( ( doc, index ) => {
				const lookupName = getLocalValue( { en: doc.DocumentNameEn, ar: doc.DocumentNameAr } );
				return <div key={ `${ doc.DocumentID }_${ index }` }>
					<span>{ lookupName }</span>
					<span>
                        <React.Fragment key={ doc.FileName }>
                            <span className="attach-doc-span flex-row align-items-center justify-content-between">
	                            <a
		                            href="#" className="underline"
		                            onClick={ e => {
			                            e.preventDefault();
			                            if ( doc.LocalData ) {
				                            const pdfResult = doc.LocalData;
				                            const pdfWindow = window.open( "" );
				                            pdfWindow?.document.write( "<iframe width='100%' height='100%' src='" + encodeURI( pdfResult + "" ) + "'></iframe>" );
			                            } else if ( doc.DocumentUrl ?? doc.DocumentURL ) {
				                            window.open( doc.DocumentURL ?? doc.DocumentUrl );
			                            }
		                            } }>
	                                { doc.FileName }
								</a>
	                            { onDelete ? <button className="btn btn-grey" onClick={ () => onDelete?.( index ) }>
		                            <i className="far fa-trash-alt"/>
	                            </button> : null }
							</span>
                        </React.Fragment>
					</span>
				</div>;
			} )
			}
		</>;
	}
	return null;
}

export default JOPService;
